<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'SectionHeadingDefault',

  props: {
    /**
     * 色の設定
     *
     * @description 「#」から始まるカラーコードで指定する。空文字の場合は CSS 変数のフォールバック（既定色）が使われる。
     */
    color: {
      type: Object as PropType<{ primary: HexColor, secondary: HexColor }>,
      default: () => ({ primary: '', secondary: '' }),
      validator: (value: { primary: string, secondary: string }) => {
        const isHexOrEmpty = (color: string) =>
          color === '' || /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color)
        return isHexOrEmpty(value.primary) && isHexOrEmpty(value.secondary)
      },
    },
  }
})
</script>

<template>
  <div
    v-if="$slots.default"
    class="o-heading__section"
    :style="{
      '--primary-color': color.primary,
      '--secondary-color': color.secondary,
    }">
    <h2 class="o-heading__section--item">
      <slot />
    </h2>
  <!-- /.o-heading__section --></div>
</template>

<style lang="sass" scoped>
// object
.o-heading__section
  margin: 2.3em 0 1.5em
  padding: 0.5em 0.67em
  background-color: var(--secondary-color, $bg-x-light-orange)
  border-left: 3px solid var(--primary-color, $border-orange)

  &:first-child
    margin-top: 0

  &:last-child
    margin-bottom: 0

  & &--item
    line-height: 1.6
    font:
      size: $font-huge
      weight: bold
</style>
